import Vue from 'vue'
import define from './systemAdminDefineMutation.js'
// define-action
const URL = process.env.API_MASTER_URL
const header = define.state.header

export default {
  inputUpdate(store, payload) {
    store.commit('inputUpdate', payload)
  },
  setLoginUser(store, payload) {
    store.commit('setLoginUser', payload)
  },
  successLoginFlag(store, response) {
    store.commit('successLoginFlag', response)
  },
  clearCompanyInfo(store) {
    store.commit('clearCompanyInfo')
  },
  setCompanyInfo(store, payload) {
    store.commit('setCompanyInfo', payload)
  },
  successLogoutFlag(store) {
    store.commit('successLogoutFlag')
  },
  changeUnauthorizedFlag(store) {
    store.commit('changeUnauthorizedFlag')
  },
  async changeAdminUserPassword(store, payload) {
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          tenantKey: payload.tenantKey,
          userId: payload.userId,
          newPassword: payload.newPassword
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/master/adminuser/password',
      data,
      config
    )
    // 成功
    store.commit('getDetail', response)
  },
  async changeMasterUserPassword(store, payload) {
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          newPassword: payload.newPassword,
          previousPassword: payload.previousPassword
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/master/masteruser/password',
      data,
      config
    )
    // 成功
    store.commit('getDetail', response)
  }
}



// WEBPACK FOOTER //
// ./src/store/systemAdminModules/systemAdminDefineModules/actions.js